import { defineStore } from "pinia";

export const useMiniCrmStore = defineStore("miniCrm", {
  state: () => {
    return {
      emulatedPersonJobId: 0,
      isRC: false,
    };
  },
  getters: {
    isRCOrEmulating: (state) => {
      return state.isRC || state.emulatedPersonJobId > 0;
    },
  },
});
